import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faCodeBranch,
  faCloudDownloadAlt,
  faGraduationCap,
  faBriefcase,
  faTerminal,
  faComment,
  faUserCircle,
  faBars,
  faTimes,
  faCaretLeft,
  faCaretRight,
  faCogs
} from '@fortawesome/free-solid-svg-icons'

import {
  faEnvelope
} from '@fortawesome/free-regular-svg-icons';

import {
  faJs,
  faReact,
  faHtml5,
  faCss3Alt,
  faSass,
  faLinkedin,
  faGithub,
  faGitAlt
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faCodeBranch,
  faCloudDownloadAlt,
  faGraduationCap,
  faBriefcase,
  faTerminal,
  faComment,
  faUserCircle,
  faBars,
  faTimes,
  faCaretLeft,
  faCaretRight,
  faCogs,
  faEnvelope,
  faJs,
  faReact,
  faHtml5,
  faCss3Alt,
  faSass,
  faLinkedin,
  faGithub,
  faGitAlt
);